<template>
    <div>
        <v-server-table name="userTable" ref="userTable" url="/users/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div class="float-left">
                    <table-filters-2 ref="userTableFilters" filterUrl="/users/list/filters" v-bind:filters="filters" :emptyFilters="filterDefs" :filterKey="filterKey" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                        <template slot-scope="slotProps">
                            <div class="d-inline-block mb-2">
                                <b-form-select v-model="slotProps.filters['user.is_subcontractor']" :options="isSubOptions" size="sm"></b-form-select>
                            </div>
                            <div class="d-inline-block mb-2">
                                <b-form-select v-model="slotProps.filters['user.IsActive']" :options="isActiveOptions" size="sm"></b-form-select>
                            </div>
                            <div class="d-inline-block mb-2">
                                <b-form-select v-model="slotProps.filters['user.is_deleted']" :options="isDeletedOptions" size="sm"></b-form-select>
                            </div>
                            <hr/>
                            <div class="d-inline-block mb-2">
                                <multi-select
                                    v-model="slotProps.filters['user.is_billable']"
                                    :btnLabel="(values) => ('Billable ('+values.length+')')"
                                    :selectOptions="isBillableOptions"
                                    :options="{multi: false}" />
                            </div>
                            <div class="d-inline-block mb-2" v-if="$store.state.user.login_type === 'graph'">
                                <multi-select
                                    v-model="slotProps.filters['user.allow_password_login']"
                                    :btnLabel="(values) => ('Login Type ('+values.length+')')"
                                    :selectOptions="isAllowPasswordLogin"
                                    :options="{multi: false}" />
                            </div>
                            <div class="d-inline-block mb-2">
                                <multi-select
                                    v-model="slotProps.filters['employee.division_id']"
                                    :btnLabel="(values) => ('Divisions ('+values.length+')')"
                                    :selectOptions="slotProps.filterData.divisions"
                                    :options="{multi: true}" />
                            </div>
                            <div class="d-inline-block mb-2">
                                <multi-select v-model="slotProps.filters['role_user.role_id']" :btnLabel="(values) => ('Roles ('+values.length+')')" :selectOptions="slotProps.filterData.roles" :options="{multi: true}"></multi-select>
                            </div>
                            <div class="d-inline-block mb-2">
                                <multi-select v-model="slotProps.filters['permission_role.permission_id']" :btnLabel="(values) => ('Permissions ('+values.length+')')" :selectOptions="slotProps.filterData.permissions" :options="{multi: true}"></multi-select>
                            </div>
                            <template v-if="$store.state.user.is_dev">
                                <hr/>

                                <div class="d-inline-block">
                                    <b-form-select v-model="slotProps.filters['user.IsDev']" :options="isDevOptions" size="sm"></b-form-select>
                                </div>
                            </template>
                        </template>
                    </table-filters-2>
                </div>

                <button type="button" class="btn btn-outline-success ml-2" v-on:click="exportTable()" :disabled="exportingTable">
                    <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                    <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                </button>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <router-link slot="UserId" slot-scope="props" :to="`/users/view/${props.row.UserId}`" :title="`View ${props.row.FirstName} ${props.row.LastName}`" class="btn btn-xs btn-secondary">
                View
            </router-link>

            <template slot="LastName" slot-scope="props">
                <router-link :to="`/users/view/${props.row.UserId}`" :title="`View ${props.row.FirstName} ${props.row.LastName}`">
                    {{ props.row.FirstName }} {{ props.row.LastName }}
                </router-link>
            </template>

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
            </template>

            <template slot="LastLoginDate" slot-scope="props">
                <template v-if="props.row.LastLoginDate">{{ props.row.LastLoginDate | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</template>
            </template>

            <template slot="email" slot-scope="props">
                <a :href="`mailto:${props.row.email}`">{{ props.row.email }}</a>
            </template>

             <template slot="DivisionName" slot-scope="props">
                <span v-if="props.row.division_code">{{ props.row.division_code }} - </span>{{ props.row.DivisionName }}
             </template>

            <template slot="IsActive" slot-scope="props">
                <span class="badge badge-danger" v-if="props.row.deleted_at != null">Deleted</span>
                <span class="badge badge-success" v-else-if="props.row.IsActive == 1">Active</span>
                <span class="badge badge-warning" v-else>Inactive</span>
            </template>

            <template slot="child_row" slot-scope="props">
                <span v-if="props.row.user_roles">
                    <span class="text-muted">Roles ({{ (props.row.user_roles.split(',')).length }})</span>:
                    <span v-for="(role, i) in props.row.user_roles.split(',')"><span v-if="i > 0">, </span>{{ role }}</span>
                </span>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';

    export default {
        props: ['assetType', 'assetId', 'allowFilterSaving'],

        data: function() {
            return {
                exportingTable: false,
                userTimezone: this.$store.state.user.timezone,
                columns: ['UserId', 'LastName', 'email', 'EmployeeNumber', 'DivisionName', 'position', 'created_at', 'LastLoginDate', 'IsActive'],
                options: {
                    headings: {
                        UserId: 'ID',
                        LastName: 'Name',
                        EmployeeNumber: 'Employee#',
                        DivisionName: 'Division',
                        position: 'Title',
                        created_at: 'Created',
                        LastLoginDate: 'Last Login',
                        IsActive: 'Status',
                        created_at: 'Created',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'user.LastName',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('userListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //INclude the asset
                        data.assetType = this.assetType;
                        data.assetId = this.assetId;

                        //Include the Deleted Flag
                        data.is_deleted = data.filters['user.is_deleted'];
                        data.is_billable = data.filters['user.is_billable'];
                        data.IsDev = data.filters['user.IsDev'];

                        //Unset some value that are handled manually
                        //delete data.filters['user.is_deleted'];
                        //delete data.filters['user.IsDev'];

                        //Send it
                        return data;
                    },
                    uniqueKey: 'UserId',
                },

                filterKey: 'userFilters',

                filterDefs: {
                    'user.is_subcontractor': null,
                    'user.IsActive': null,
                    'user.IsDev': null,
                    'user.is_deleted': null,
                    'user.is_billable': [],
                    'user.allow_password_login': [],
                    'employee.division_id': [],
                    'role_user.role_id': [],
                    'permission_role.permission_id': [],
                },
            }
        },

        computed: {
            isSubOptions(){
                //Send it
                return [
                    {value: null, text: '-- Select Subcontractor (Showing All Users) --'},
                    {value: false, text: 'Hide Subcontractor Users'},
                    {value: true, text: 'Only Subcontractor Users'},
                ];
            },

            isActiveOptions(){
                //Send it
                return [
                    {value: null, text: '-- Select Active (Showing All Users) --'},
                    {value: 0, text: 'Inactive Users'},
                    {value: 1, text: 'Active Users'},
                ];
            },

            isDevOptions(){
                //Send it
                return [
                    {value: null, text: '-- Select Dev (Showing All Users) --'},
                    {value: false, text: 'Hide Developer Users'},
                    {value: true, text: 'Only Developer Users'},
                ];
            },

            isBillableOptions(){
                //Send it
                return [
                    {id: 'billable', name: 'Only Billable Users (Has at least 1 Permission)'},
                    {id: 'free', name: 'Only Free Users (No Permissions, Usually Subcontractor Users)'},
                ];
            },

            isAllowPasswordLogin(){
                //Send it
                return [
                    {id: 1, name: 'Allows Password Login'},
                    {id: 0, name: 'Single-Sign On (SSO) Only'},
                ];
            },

            isDeletedOptions(){
                //Send it
                return [
                    {value: null, text: '-- Select Deleted (Showing All Users) --'},
                    {value: false, text: 'Hide Deleted Users'},
                    {value: true, text: 'Only Deleted Users'},
                ];
            },

            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },
        },

        watch: {
            //Watcher for errors
            getDeleted(newValue, oldValue){
                //Set it
                this.$refs.userTable.refresh();
            },

            getDev(newValue, oldValue){
                //Set it
                this.$refs.userTable.refresh();
            },

            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        methods: {

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the Column
                var cols = this.$refs.userTable.columns;

                //Push Roles
                cols.push('user_roles');

                //Build the payload
                var payload = {
                    table: 'userTable',
                    filters: filterExtractor.extractFilters(this.filters),
                    query: (this.$refs.userTable.getRequestParams()).query,
                    orderBy: this.$refs.userTable.options.orderBy.column,
                    ascending: this.$refs.userTable.options.orderBy.ascending,
                    columns: cols,
                };

                //Send it
                this.$http.get('/users/list?export=true', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Users');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.userTable.setPage(1);
                this.$refs.userTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.userTableFilters.resetColVis(this.$refs.userTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.userSavedFilters.setFilterParams(this.$refs.userTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.userTableFilters.setColVis(this.$refs.userTable);
            },
        },

        mounted(){

        }
    }
</script>
